import Constants from '../../utils/Constants';
import { NewPdnShortcut, ShortcutProps } from './Utils';

export const NewPdnActuatorAoM = () => {
  const props: ShortcutProps = {
    projectNameKey: 'NewActuatorAoMProject',
    systemNameKey: 'NewActuatorAoMSystem',
    systemTypeUniqueId: Constants.systemTypes.pdn.multiPart,
    autoExecAction: Constants.autoExecActions.launchSizingTool,
    groupUniqueName: Constants.groupsDefinitions.pdn.application,
    partCategoryName: Constants.partCategories.pdn.actuatorAoM,
  };

  return NewPdnShortcut(props);
};
